<section
  class="general-availability-calendar"
  [ngClass]="{
    'general-availability-calendar--dashboard tutor': !isStudent,
    'custom-styling': hideTitleAndDescription,
  }"
>
  @if (!isStudent && !hideTitleAndDescription) {
    <div class="general-availability-calendar__section-title" translate>
      texts.Dashboard_Your_Weekly_Calendar
    </div>
  }
  @if (tutorAvailability) {
    <div class="general-availability-calendar__container">
      <div class="calendar-actions-and-title">
        @if (isStudent) {
          <div
            class="title"
            translate
            [translateParams]="{ tutorName: tutorName }"
          >
            texts.Availability_Calendar_Title
          </div>
        }
      </div>
      <p class="general-availability-calendar__text" translate>
        @if (isStudent) {
          texts.Availability_Calendar_Explanation_Text
        } @else {
          texts.Availability_Calendar_Explanation_Text_Tutor
        }
        @if (!hideTitleAndDescription) {}
      </p>
      @if (!isStudent) {
        <div class="popular-slots-row">
          <div class="popular-slots-info">
            <div class="popular-slots-info__header">
              <i
                class="fa-thin fa-arrow-up-right-dots popular-slots-info__icon"
              ></i>
              <span class="popular-slots-info__title" translate
                >texts.Availability_Calendar_Popular_Title</span
              >
            </div>
            <p class="popular-slots-info__description" translate>
              texts.Availability_Calendar_Popular_Description
            </p>
          </div>
          @if (authService.userDetails?.tutorDetails && !isTogglesHidden) {
            <div class="calendar-actions">
              <div class="calendar-actions-toggle">
                <app-slide-toggle
                  [(value)]="
                    authService.userDetails.tutorDetails._acceptsNewStudents
                  "
                  (valueChange)="onUpdateNewAvailability()"
                >
                </app-slide-toggle>
                <span translate>
                  texts.Availability_Calendar_New_Student_Toggle
                </span>
              </div>
              <div class="calendar-actions-toggle">
                <app-slide-toggle
                  [(value)]="
                    authService.userDetails.tutorDetails._offersAtHomeLessons
                  "
                  (valueChange)="onUpdateAtHomeLessons()"
                >
                </app-slide-toggle>
                <span translate>
                  texts.Tutor_Offers_At_Home_Lessons_Toggle
                </span>
              </div>
            </div>
          }
        </div>
        @if (
          authService.userDetails?.tutorDetails &&
          !isTogglesHidden &&
          !authService.userDetails.tutorDetails._offersAtHomeLessons
        ) {
          <div class="at-home-lessons-note" translate>
            texts.Tutor_Offers_At_Home_Lessons_Off_Note
          </div>
        }
      }
      @if (isCalendarEmpty && isStudent) {
        <div class="general-availability-calendar__no-calendar no-calendar">
          <p
            class="no-calendar__text"
            translate
            [translateParams]="{ tutorName: tutorName }"
          >
            texts.Availability_Calendar_No_Calendar_Text
          </p>
        </div>
      } @else {
        <div
          class="general-availability-calendar__calendar calendar calendar--full"
        >
          <div class="calendar__head">
            <div class="day" translate>
              texts.Availability_Calendar_Label_Sunday
            </div>
            <div class="day" translate>
              texts.Availability_Calendar_Label_Saturday
            </div>
            <div class="day" translate>
              texts.Availability_Calendar_Label_Friday
            </div>
            <div class="day" translate>
              texts.Availability_Calendar_Label_Thursday
            </div>
            <div class="day" translate>
              texts.Availability_Calendar_Label_Wednesday
            </div>
            <div class="day" translate>
              texts.Availability_Calendar_Label_Tuesday
            </div>
            <div class="day" translate>
              texts.Availability_Calendar_Label_Monday
            </div>
          </div>
          <div class="calendar__body">
            <div class="legend">
              <div class="period">
                <span translate>texts.Availability_Calendar_Label_Morning</span>
                <span translate
                  >texts.Availability_Calendar_Label_Morning_Time</span
                >
              </div>
              <div class="period">
                <span translate>texts.Availability_Calendar_Label_Midday</span>
                <span translate
                  >texts.Availability_Calendar_Label_Midday_Time</span
                >
              </div>
              <div class="period">
                <span translate
                  >texts.Availability_Calendar_Label_Afternoon</span
                >
                <span translate
                  >texts.Availability_Calendar_Label_Afternoon_Time</span
                >
              </div>
              <div class="period">
                <span translate>texts.Availability_Calendar_Label_Evening</span>
                <span translate
                  >texts.Availability_Calendar_Label_Evening_Time</span
                >
              </div>
            </div>
            @for (day of tutorAvailability; track day.day; let i = $index) {
              <div class="day">
                @for (
                  period of [].constructor(4);
                  track $index;
                  let j = $index
                ) {
                  @if (isStudent) {
                    <div
                      class="period"
                      [ngClass]="{
                        'period--available': day.periods.includes(j + 1),
                      }"
                      (click)="
                        onSelectPeriod(
                          i == 6 ? 0 : i + 1,
                          j + 1,
                          day.periods.includes(j + 1)
                        )
                      "
                    ></div>
                  }
                  @if (!isStudent) {
                    <div
                      class="period"
                      [ngClass]="{
                        'period--available': day.periods.includes(j + 1),
                      }"
                      (click)="
                        onSelectPeriod(
                          i == 6 ? 0 : i + 1,
                          j + 1,
                          day.periods.includes(j + 1)
                        )
                      "
                    >
                      @if (popularSlots.has(i + "-" + (j + 1))) {
                        <i
                          class="fa-thin fa-arrow-up-right-dots popular-badge"
                        ></i>
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>
        </div>
        <div
          class="general-availability-calendar__calendar calendar calendar--mobile"
        >
          <div class="legend">
            <div class="period">
              <span translate>texts.Availability_Calendar_Label_Morning</span>
              <span translate
                >texts.Availability_Calendar_Label_Morning_Time</span
              >
            </div>
            <div class="period">
              <span translate>texts.Availability_Calendar_Label_Midday</span>
              <span translate
                >texts.Availability_Calendar_Label_Midday_Time</span
              >
            </div>
            <div class="period">
              <span translate>texts.Availability_Calendar_Label_Afternoon</span>
              <span translate
                >texts.Availability_Calendar_Label_Afternoon_Time</span
              >
            </div>
            <div class="period">
              <span translate>texts.Availability_Calendar_Label_Evening</span>
              <span translate
                >texts.Availability_Calendar_Label_Evening_Time</span
              >
            </div>
          </div>
          <mat-tab-group
            animationDuration="0ms"
            class="calendar__tabs"
            [selectedIndex]="firstAvailableDayIndex"
          >
            @for (day of tutorAvailability; track day.day; let i = $index) {
              <mat-tab class="day" label="{{ day.dayShortLabel | translate }}">
                @for (
                  period of [].constructor(4);
                  track $index;
                  let j = $index
                ) {
                  <div
                    class="period"
                    [ngClass]="{
                      'period--available': day.periods.includes(j + 1),
                    }"
                    (click)="
                      onSelectPeriod(
                        i == 6 ? 0 : i + 1,
                        j + 1,
                        day.periods.includes(j + 1)
                      )
                    "
                  >
                    @if (!isStudent && popularSlots.has(i + "-" + (j + 1))) {
                      <i
                        class="fa-thin fa-arrow-up-right-dots popular-badge"
                      ></i>
                    }
                  </div>
                }
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      }
    </div>
  }
</section>
